import React from "react";

const Footer = () => (
  <footer className="footer" data-testid="footer">
    <div className="footer-florals" aria-hidden="true">
      <svg viewBox="0 0 400 120" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#b08c48" strokeWidth="1" fill="none" opacity="0.7">
          <path d="M20 90 C 60 40, 120 40, 200 80" />
          <path d="M380 90 C 340 40, 280 40, 200 80" />
          <circle cx="50" cy="70" r="3" fill="#b08c48" />
          <circle cx="80" cy="55" r="4" fill="#b08c48" />
          <circle cx="120" cy="48" r="3" fill="#b08c48" />
          <circle cx="160" cy="60" r="2" fill="#b08c48" />
          <circle cx="240" cy="60" r="2" fill="#b08c48" />
          <circle cx="280" cy="48" r="3" fill="#b08c48" />
          <circle cx="320" cy="55" r="4" fill="#b08c48" />
          <circle cx="350" cy="70" r="3" fill="#b08c48" />
        </g>
      </svg>
    </div>
    <div className="footer-mono">R &amp; T</div>
    <p className="footer-date">21st November 2026</p>
    <p className="footer-note">Foxhill Manor · The Cotswolds</p>
    <div className="footer-glyph">✽</div>
  </footer>
);

export default Footer;
